import React, {useEffect, useState} from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { BiChevronRight, BiFolder  } from "react-icons/bi";
import portalService from '../services/portalService';
import localStorageService from '../services/localStorageService';
import { MdLocationCity, MdOutlineLocationCity, MdOutlineLocationOn } from 'react-icons/md';

const LocationsSidebar = () => {
    const navigate = useNavigate();
    const [locations, setLocations] = useState({});

    const [selectedCity, setSelectedCity] = useState(0);
    const [selectedOwner, setSelectedOwner] = useState(0);
    const [locationName, setLocationName] = useState("");
    const [locationAddress, setLocationAddress] = useState("");
    const [locationLatitude, setLocationLatitude] = useState(0.0);
    const [locationLongitude, setLocationLongitude] = useState(0.0);
    const [offlineLocation, setOfflineLocation] = useState(false);

    useEffect(() => {
        let owners = localStorageService.owners.get();
        let localCities = localStorageService.cities.get();
        let locs = localStorageService.locations.get();
        setSelectedOwner(owners[0].id);
        setSelectedCity(localCities[0].id);
        setLocations(locs);
    }, []);

    const addNew = (e) => {       
        const existing = {...locations};
        const newLocation = {
            name: locationName,
            address: locationAddress,
            latitude: locationLatitude,
            longitude: locationLongitude,
            cityId: selectedCity,
            ownerId: selectedOwner,
            isOffline: offlineLocation === "true" ? true : false 
        };
        console.log("Adding new", newLocation);
        portalService.addLocation(newLocation)
            .then(l => {
                console.log("new location", l);
                existing[l.data.id] = { ...newLocation, storageItems: [], id: l.data.id };
                console.log("Adding new location", newLocation);
                localStorageService.locations.set(existing);
                setLocations(existing);
                clearFields();
                navigate(`/locations/${l.data.id}`);
            });
    }

    const modalClosed = (e) => {
        clearFields();
    }

    const clearFields = () => {
        setLocationAddress("");
        setLocationName("");
        const owners = localStorageService.owners.get();
        const localCities = localStorageService.cities.get();
        setSelectedOwner(owners[0].id);
        setSelectedCity(localCities[0].id);
        setLocationLongitude(0);
        setLocationLatitude(0);
        setOfflineLocation(false);
    }

    const modal = () => {
        console.log("local cities", localStorageService.cities.get());
        return (
            <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 v="modal-title fs-5" id="staticBackdropLabel">Новая локация</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form className="form-floating">
                                <div className="form-floating mb-3">
                                    <select className="form-select" id="location-owner" aria-label="Default select example"
                                        value={selectedOwner}
                                        onChange={e => setSelectedOwner(e.target.value)}>
                                            {localStorageService && localStorageService.owners && localStorageService.owners.get() && localStorageService.owners.get().map(c => (
                                                <option key={`owner-${c.id}`} value={c.id}>{c.name}</option>
                                            ))}
                                    </select>
                                    <label htmlFor="location-owner">Владелец</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <select className="form-select" id="location-city" aria-label="Default select example"
                                        value={selectedCity}
                                        onChange={e => setSelectedCity(e.target.value)}>
                                            {localStorageService && localStorageService.cities && localStorageService.cities.get() && localStorageService.cities.get().map(c => (
                                                <option key={`city-${c.id}`} value={c.id}>{c.name}</option>
                                            ))}
                                    </select>
                                    <label htmlFor="location-city">Город</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="text" className="form-control" id="new-location-name" required placeholder="" value={locationName} onChange={(e) => setLocationName(e.target.value)}/>
                                    <label htmlFor="new-location-name">Название локации</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="text" className="form-control" id="new-location-address" placeholder="" value={locationAddress} onChange={(e) => setLocationAddress(e.target.value)}/>
                                    <label htmlFor="new-location-address">Адрес</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="number" className="form-control" id="new-location-address" placeholder="" value={locationLatitude} onChange={(e) => setLocationLatitude(e.target.value)}/>
                                    <label htmlFor="new-location-address">Долгота</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="number" className="form-control" id="new-location-address" placeholder="" value={locationLongitude} onChange={(e) => setLocationLongitude(e.target.value)}/>
                                    <label htmlFor="new-location-address">Широта</label>
                                </div>
                                <div className="mb-3 form-check">
                                    <input type="checkbox" className="form-check-input" id="is-offline" value={offlineLocation} onChange={(e) => setOfflineLocation(e.target.value)}/>
                                    <label className="form-check-label" htmlFor="is-offline">Офлайн локация</label>
                                </div>
                                <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={modalClosed}>Закрыть</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={addNew}>Сохранить</button>
                        </div>
                            </form>
                        </div>
                        
                    </div>
                </div>
            </div>
        );
    };

    return (
        <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Локации
          </a>

            <ul className="dropdown-menu" id="projectsMenu">
            <li key='new-location-btn' className="nav-item">
                    <NavLink
                        to='#'
                        className='nav-link'
                    >
                        <button type="button" className="btn btn-primary w-100" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
Добавить +
</button>
                    </NavLink>
                </li>
                {Object.entries(locations).map((loc, indx) => (
                    <li key={`location-${loc[1].id}`} className="dropdown-item" href="#">
                        
                        <NavLink
                            to={`/locations/${loc[1].id}`}
                            className={({ isActive }) =>
                                isActive ? 'nav-link active' : 'nav-link'
                            }
                        >
                            <MdOutlineLocationOn className="me-2 text-danger" /> {loc[1].name}
                        </NavLink>
                    </li>
                ))}
            </ul>
            {modal()}
        </li>);
};

export default LocationsSidebar;